'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoSquirrel = function GoSquirrel(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 2.5c-5.5 0-10 3.3-10 7.3 0 4.8 1.3 7.6 0 15.2 0-11.2-6.9-15.8-10-15.8 0.1-1.3-1.2-1.7-1.2-1.7s-0.6 0.3-0.8 0.8c-0.6-0.7-1.4-0.6-1.4-0.6l-0.3 1.4s-4.6 1.6-4.6 8.1c0.5 0.8 3.8 1.5 6.2 1 2.2 0.2 1.7 2 1.2 2.5-2.1 2.1-4.1-0.7-6.6-0.7s-2.5 2.5 0 2.5 2.5 2.5 7.5 2.5c-7.7 3 0 10 0 10h-2.5c-2.5 0-2.5 2.5-2.5 2.5h15c7.5 0 12.5-2.5 12.5-8.7 0-2.1-1.1-4.5-2.5-6.3-2.8-3.7 0.6-6.7 2.5-5s7.5 2.5 7.5-5c0-5.5-4.5-10-10-10z m-23.7 12.5c-0.7 0-1.3-0.6-1.3-1.2s0.6-1.3 1.3-1.3 1.2 0.6 1.2 1.3-0.6 1.2-1.2 1.2z' })
        )
    );
};

exports.default = GoSquirrel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/squirrel.js
// module id = 1808
// module chunks = 0